<template>
  <b-card>
    <layout-loading v-if="itemLoading" />
    <b-form v-if="render">
      <b-row>
        <b-col md="12">
          <b-form-group
            :label="$t('general.title')"
            label-for="theme-setting-title"
            :state="validateState('title')"
          >
            <b-form-input
              id="theme-setting-title"
              v-model="form.title"
              :label="$t('general.title')"
              aria-describedby="input-title-feedback"
            />
            <b-form-invalid
              id="input-title-feedback"
              :label="$t('general.title')"
              :validator="$v.form.title"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('themeSettings.redirectOldLink')"
            label-for="redirectSettings-add-oldLink"
            :state="validateState('oldLink')"
          >
            <b-form-input
              id="redirectSettings-add-oldLink"
              v-model="form.oldLink"
              dir="ltr"
              :label="$t('themeSettings.redirectOldLink')"
              aria-describedby="input-title-feedback"
            />
            <b-form-invalid
              id="input-title-feedback"
              :label="$t('general.title')"
              :validator="$v.form.oldLink"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            :label="$t('themeSettings.redirectNewLink')"
            label-for="redirectSettings-add-newLink"
            :state="validateState('newLink')"
          >
            <b-form-input
              id="redirectSettings-add-newLink"
              v-model="form.newLink"
              dir="ltr"
              :label="$t('themeSettings.redirectNewLink')"
              aria-describedby="input-title-feedback"
            />
            <b-form-invalid
              id="input-title-feedback"
              :label="$t('general.title')"
              :validator="$v.form.newLink"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <ul class="mustLaw">
            <li>
              * {{ $t('themeSettings.charLength') }}
            </li>
            <li>
              * {{ $t('themeSettings.mustChar') }}
            </li>
          </ul>
        </b-col>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isSubmit"
            @click="submitForm"
          >
            {{ isSubmit ? $t("general.isSubmit") : $t("general.submit") }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="$router.go(-1)"
          >
            {{ $t("general.back") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>
<script>
import {
  BButton, BCard, BCol, BForm, BFormGroup, BFormInput, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, minLength } from 'vuelidate/lib/validators'
import '@/components/language-selector.vue'
import BFormInvalid from '@/components/BFormInvalid/index.vue'
import '@/components/BFileInput/index.vue'
import LayoutLoading from '@/components/LayoutLoading.vue'
import '@/components/VSelectCustom/index.vue'
import '@/components/CkeditorBasic/index.vue'
import RedirectSettingsList from './useRedirectSettingsList'

export default {
  name: 'ThemeSettingEdit',
  components: {
    BButton,
    BCard,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalid,
    BRow,
    LayoutLoading,
  },
  directives: {
    Ripple,
  },
  validations() {
    return {
      form: {
        title: {
          required,
          minLength: minLength(3),
        },
        newLink: {
          required,
          minLength: minLength(3),
        },
        oldLink: {
          required,
          minLength: minLength(3),
        },
      },
    }
  },
  setup() {
    const {
      convertResource,
      errorManager,
      fetchItem,
      fetchTags,
      form,
      handleUpload,
      isSubmit,
      item,
      itemLoading,
      tags,
      updateItem,
    } = RedirectSettingsList()
    return {
      convertResource,
      errorManager,
      fetchItem,
      fetchTags,
      form,
      handleUpload,
      isSubmit,
      item,
      itemLoading,
      tags,
      updateItem,
    }
  },
  computed: {
    itemId() {
      return this.$router.currentRoute.params.id
    },
    render() {
      return this.item ? this.item && Object.keys(this.item).length : true
    },
  },
  created() {
    this.fetchItem(this.itemId)
  },
  methods: {
    validateState(name) {
      const {
        $dirty,
        $error,
      } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    submitForm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.errorManager('validator.validationError')
        setTimeout(() => document.getElementsByClassName('is-invalid')[0].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        }), 500)
        return
      }
      this.sendData(this.form)
    },
    sendData(form) {
      const data = {
        title: form.title,
        newLink: form.newLink,
        oldLink: form.oldLink,
      }
      this.updateItem(this.itemId, data, this.form.lang)
    },
  },
}
</script>
<style>
.mustLaw{
  background: #e3e3e36d;
  border-radius: 6px;
  padding: 5px 10px;
}
.mustLaw li {
  padding: 5px 0;
  list-style: none;
}
</style>
